export function getGroupedModelKeys<TFilter>(
  model: TFilter
): ReadonlyMap<string, Set<string>> {
  const rv = Object.keys(model || {}).reduce((groups, field) => {
    const [base] = field.split('_');
    groups.set(base, (groups.get(base) || new Set()).add(field));
    return groups;
  }, new Map<string, Set<string>>());
  return rv;
}
